export const GET_DIVISION = 'GET_DIVISION'
export const GET_DIVISIONS_TASK_ARE_ASSIGNED_TO = 'GET_DIVISIONS_TASK_ARE_ASSIGNED_TO'
export const GET_ALL_DIVISIONS = 'GET_ALL_DIVISIONS'
export const UPDATE_DIVISION = 'UPDATE_DIVISION'
export const DELETE_DIVISION = 'DELETE_DIVISION'
export const CREATE_DIVISION = 'CREATE_DIVISION'
export const RESET_DIVISION = 'RESET_DIVISION'
export const GET_DIVISIONS_FOR_SELECT = 'GET_DIVISIONS_FOR_SELECT'
